import React from 'react'
import styles from './groups-modal-footer.styles'
import injectSheet from 'react-jss'
import { ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'

const GroupsModalFooter = ({ classes, onCancel, onSubmit, disabled }) => (
  <ModalFooter className={classes.footer}>
    <Button tall simple action={onCancel}>
      Cancel
    </Button>
    <Button disabled={disabled} tall action={onSubmit}>
      Apply filter
    </Button>
  </ModalFooter>
)

export default injectSheet(styles)(GroupsModalFooter)
